/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
// This file is help with consistent naming of default imports throughout the files.
import classNamesDefault from 'classnames';
// Fix for error: Exported variable 'classNames' has or is using name 'ClassNames' from external module "/Users/karl/development/neo4j/neo4j-design-2/node_modules/classnames/index" but cannot be named.ts(4023)
// https://github.com/JedWatson/classnames/blob/main/index.d.ts#L18
export const classNames = classNamesDefault;
//# sourceMappingURL=defaultImports.js.map